export default "__VITE_ASSET__DrMAsbhO__"